import { Component, Input, OnInit } from '@angular/core';
import { isOrigemLancamentoCadastroErp, isOrigemLancamentoCadastroEcommerce } from '../../../../models/origem-lancamento-cadastro';

interface Config {
    isOrigemERP: boolean;
    isOrigemEcommerce: boolean;
}

@Component({
    selector: 'sgt-plataforma-origem-badge',
    templateUrl: './plataforma-origem-badge.component.html',
    styleUrls: ['./plataforma-origem-badge.component.less']
})
export class PlataformaOrigemBadgeComponent implements OnInit {
    config: Config;

    @Input() origem: number;
    // ERP
    @Input() logoURLErp: string;
    @Input() nomeErp: string;
    // E-commerce
    // ERP
    @Input() logoURLEcommerce: string;
    @Input() nomeEcommerce: string;

    @Input() logoURLWidth = '30px';
    @Input() isShowNome = true;

    ngOnInit(): void {
        this.setConfig();
    }

    private setConfig() {
        this.config = {
            isOrigemERP: isOrigemLancamentoCadastroErp(this.origem ?? null),
            isOrigemEcommerce: isOrigemLancamentoCadastroEcommerce(this.origem ?? null),
        }
    }
}
